module.exports = __webpack_public_path__ + "img/dollar-atm.3c25ae4e.svg";